export class LoginData {
  constructor(public username?: string, public password?: string) {}
}
